import { render, staticRenderFns } from "./kindChooseViewktypevip.vue?vue&type=template&id=32846f86&scoped=true"
import script from "./kindChooseViewktypevip.vue?vue&type=script&lang=js"
export * from "./kindChooseViewktypevip.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViewktypevip.vue?vue&type=style&index=0&id=32846f86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32846f86",
  null
  
)

export default component.exports